import { BRANDING_TOKENS } from "./tokens.js";
/**
 * The GatiQ factory defaults, built from the token registry.
 * The `platformsettings` document is seeded with exactly this.
 */
export const FACTORY_BRANDING = Object.freeze(Object.fromEntries(BRANDING_TOKENS.map((t) => [t.key, t.default])));
/** A fresh organization stores null for every token — i.e. inherit everything. */
export function emptyOverrides() {
    return Object.fromEntries(BRANDING_TOKENS.map((t) => [t.key, null]));
}
/** True when this org has not overridden anything and is showing platform branding. */
export function isFullyInherited(overrides) {
    if (!overrides)
        return true;
    return BRANDING_TOKENS.every((t) => {
        const v = overrides[t.key];
        return v === null || v === undefined || v === "";
    });
}
/** Which tokens this org has actually overridden — used by the "↺ reset" affordance. */
export function overriddenKeys(overrides) {
    if (!overrides)
        return [];
    return BRANDING_TOKENS.filter((t) => {
        const v = overrides[t.key];
        return v !== null && v !== undefined && v !== "";
    }).map((t) => t.key);
}
//# sourceMappingURL=defaults.js.map